export default __webpack_public_path__ + "static/media/motofix.333164ec.png";